import { ComparisonType } from './ComparisonType';

export class Field {
  public readonly name: string;
  public readonly description: string;
  public comparisonType: ComparisonType;
  private __className: string;
  public readonly __uuid: string;

  constructor(name: string, description: string, className: string, comparisonType: ComparisonType) {
    this.name = name;
    this.description = description;
    this.comparisonType = comparisonType;
    this.__className = className;
    this.__uuid = UUID.generate();
  }

  public clone(): Field {
    const instance = Object.create((this as Object).constructor.prototype);

    return {instance, ...this, __uuid: UUID.generate()} as Field;
  }
}
